import React, { FC, useState } from 'react';
import { Box, Card, Label, PieChart, Tooltip, Typography } from '@scope/scope-one-ui/core';
import Info from 'assets/icons/info.svg';
import { COLORS, SIZES } from '@scope/scope-one-ui/theme';
import { ValueChainInfoCardProps } from './ClimateChangeRisk.d';
import { ChartContainer, Dot } from './ClimateChangeRisk.styled';

export const ValueChainInfoCard: FC<ValueChainInfoCardProps> = ({ title, tooltip, data }) => {
  const [activeIndex, setActiveIndex] = useState<number>();
  const onPieEnter = (_, index) => setActiveIndex(index);
  const onPieLeave = () => setActiveIndex(undefined);

  return (
    <Card>
      <Box display="flex" justifyContent="space-between" p={2}>
        <Box display="flex" flexDirection="column" justifyContent="space-between">
          <Box display="flex" gridGap={1} alignItems="center">
            <Label>{title}</Label>
            <Tooltip content={tooltip} position="bottom">
              <Box display="flex">
                <Info
                  width={SIZES.spacing(2)}
                  height={SIZES.spacing(2)}
                  color={COLORS.typography.main}
                />
              </Box>
            </Tooltip>
          </Box>
          {data.map(({ name, value, color }) => (
            <Box key={name} display="flex" flexDirection="column" gridGap={2}>
              <Box display="flex" alignItems="center" gridGap={1}>
                <Dot color={color!} />
                <Typography variant="body1" color={COLORS.typography.main}>
                  {name}
                </Typography>
              </Box>
              <Typography variant="h1" color={COLORS.typography.label}>
                {value.toFixed(2)} %
              </Typography>
            </Box>
          ))}
        </Box>
        <ChartContainer>
          <PieChart
            variant="small"
            chartData={data}
            activeIndex={activeIndex}
            onPieEnter={onPieEnter}
            onPieLeave={onPieLeave}
          />
        </ChartContainer>
      </Box>
    </Card>
  );
};
